import { AdDetails } from '@amzn/safeframe-model';
import { ClientMessageToHost } from '@/components/messenger.js';
import { errorLog } from '@/client/commonSf.js';
import { EventsChannel } from '@/components/messageChannel/eventsChannel.js';

export const createClientEventsChannel = (mp: MessagePort): EventsChannel => {
    return {
        onSafeFrameReady: (adDetails: AdDetails) => sendMessage(mp, 'onSafeFrameReady', adDetails),
        onPreCreativeWrite: (adDetails: AdDetails) => sendMessage(mp, 'onPreCreativeWrite', adDetails),
        onPostCreativeWrite: (adDetails: AdDetails) => sendMessage(mp, 'onPostCreativeWrite', adDetails),
        onCreativeBeginToRender: (adDetails: AdDetails) => sendMessage(mp, 'onCreativeBeginToRender', adDetails),
        onCreativeLoad: (adDetails: AdDetails) => sendMessage(mp, 'onCreativeLoad', adDetails),
        onError: (adDetails: AdDetails) => sendMessage(mp, 'onError', adDetails),
        onClick: (adDetails: AdDetails) => sendMessage(mp, 'onClick', adDetails),
    };
};

const sendMessage = (messagePort: MessagePort, command: keyof EventsChannel, adDetails: AdDetails): void => {
    const msg: ClientMessageToHost = {
        command: command,
        adDetails: adDetails,
        payload: {},
    };

    try {
        messagePort.postMessage(msg);
    } catch (ex) {
        errorLog('Post Message error', ex as Error);
    }
};
